<template>
  <div id="cyclic-definition_create">
    <v-form
      ref="form"
      lazy-validation
      >
      <v-text-field
        v-model="form.name"
        :label="`${$t('cyclic.name')}`"
        :rules="nameRules"
        required
      ></v-text-field>

      <v-slider
      v-model="form.interval"
      :label="`${$t('cyclic.interval')}`"
      thumb-label="always"
      >
    </v-slider>

        <v-select
        v-model="form.interval_unit"
        item-text="name"
        item-value="unit"
        :items="unit"
        :label="`${$t('cyclic.create.time_unit')}`"
      >  </v-select>

            <v-select
                v-model="form.team"
                :items="teams"
                item-text="name"
                item-value="id"
                :label="`${$t('cyclic.supervisor')}`"
                :rules="teamRules"
                required
            >
            </v-select>

      <v-select
        v-model="form.active"
        :items="status"
        item-text="name"
        :label="`${$t('cyclic.status')}`"
        :rules="statusRules"
        required
      ></v-select>

      <v-btn
        color="primary"
        @click="submit"
      >
        {{ $t('cyclic.continue') }}
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import http from '@/plugins/http'

export default {
  components: {
  },
  data() {
    return {
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length > 3) || 'Name must be less than 3 characters',
      ],
      intervalRules: [v => !!v],
      teamRules: [v => !!v || "Team is required"],
      statusRules: [v => !!v || "Status is required"],
      basicValid: false,
      stepper: 1,
      loading: false,
      e1: 0,
      teams: [],
      form: {}

    }
  },
  computed: {
    status (){
      return [{"name":this.$t('inactive') ,"value": 0 }, {"name":this.$t('active') ,"value": 10 }]
    },
    unit() {
      return  [{"unit":"day","name": this.$t('cyclic.day') },{"unit":"month","name": this.$t('cyclic.month') }]
    }
  },
  created() {
    this.loadTeams()
  },
  methods: {
    loadTeams(){
      this.loading = true
      http.get('teams')
        .then(({ data }) => {
          this.teams=data;
        })
      this.loading = false
    },
    submit(){
      if (this.$refs.form.validate()) {
        let postData={
          "supervisory_team_id":this.form.team,
          "name":this.form.name,
          "status": this.form.active,
          "interval":this.form.interval + " " + this.form.interval_unit
        }
        http.post('cyclic/create-definition', postData)
          .then(({ data }) => {
            this.$emit("definition-created",data.id)
          })
      }
    }
  },
}
</script>

<style>

</style>
